export let AppActionTypes;
(function (AppActionTypes) {
  AppActionTypes["UpdateKeyValue"] = "[App] Update Key Value";
  AppActionTypes["AppStarted"] = "[App] App Started";
  AppActionTypes["SignupCompleted"] = "[App] Signup Completed";
  AppActionTypes["SignupEnded"] = "[App] Signup Ended";
  AppActionTypes["EmbeddedPrefill"] = "[App] Embedded Prefill";
  AppActionTypes["UpdateCookiePreferences"] = "[App] Update Cookie Preferences";
})(AppActionTypes || (AppActionTypes = {}));